import * as actionTypes from '../../actions/authentication/authAction';
import {CurrentUser} from '../../services/CurrentUser';

const initialState = {
    status: '',
    redirectTo: undefined,
    transferInfo: {
        redirectTo: ''
    },
    role: 'none'
};

export default function authenticationRiskReducer(state = initialState, action) {
    switch (action.type) {

        case actionTypes.GET_TRANSFER_SUCCESS: {
            CurrentUser.setTokenInfo(action.transferInfo.authToken,
                action.transferInfo.refreshToken,
                action.transferInfo.userId,
                action.transferInfo.refreshTokenExpirationMinutes,
                action.transferInfo.authTokenLifetimeInSeconds);

            return {...state,
                status: "TransferInfoReceived",
                redirectTo: action.transferInfo.requestedReturnUrl };
        }

        case actionTypes.GET_TRANSFER_FAIL: {

            return {...state, status: "FailToFetchTransferInfo" };
        }

        default:
            return state;
    }
}
